module.exports = __webpack_public_path__ + "static/img/tx.3ee4186d.png";